import { render, staticRenderFns } from "./PythonLogo.vue?vue&type=template&id=90bb36a2"
import script from "./PythonLogo.vue?vue&type=script&lang=js"
export * from "./PythonLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports